import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DateRange from "../../components/DateRangePicker";
import SearchIcon from "@mui/icons-material/Search";
import SearchBox from "../../components/searchBox";
import TextBox from "../../components/textbox";
import { axios } from "../../utils/axios";
import { format, addDays, addMonths } from "date-fns";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import NOHOTELIMG from "../../assets/images/trip/noHotel.png";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Tooltip from "@mui/material/Tooltip";
import Loader from "../../components/Loader";
import { formatDateToEEE_MM_d } from "../../utils/utils";
const AddHotel = ({ tripId }) => {
  const navigate = useNavigate();
  const [occupancySelector, setOccupancySelector] = useState({
    rooms: 1,
    adults: 2,
    children: [],
  });
  const [savedHotels, setSavedHotels] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [addAdultsPop, setAddAdultsPop] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: addMonths(new Date(), 2),
      endDate: addDays(addMonths(new Date(), 2), 3),
      key: "selection",
    },
  ]);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState({ status: false, data: null });
  const [loader, setLoader] = useState(false);
  const [openShareTripPopup, setOpenShareTripPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    getSavedHotels();
  }, []);

  const cancelbooking = () => {
    setLoader(true);
    axios
      .post(
        process.env.REACT_APP_BACKEND_ZENTRUM +
          `cancelbooking?bId=${selectedData?.bookingId}`
      )
      .then((resp) => {
        if (resp.data.status) {
          toast.success(resp.data.message);
          getSavedHotels();
          setCancelPopUp(false);
          setSelectedItem(null);
          setLoader(false);
        } else {
          setCancelPopUp(false);
          toast.error(resp.data.message);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        setCancelPopUp(false);
        setSelectedItem(null);
        toast.error(err?.response?.data?.message);
      });
  };
  const checkAvaibality = (data) => {
    if (data?.status?.toLowerCase() === "booked") {
      setCancelPopUp(true);
      setSelectedData(data);
    } else {
      setLoader(true);
      axios
        .get(
          process.env.REACT_APP_BACKEND +
            `trip/checkroomavailablity?roomid=${data?._id}`
        )
        .then((resp) => {
          setLoader(false);
          if (resp.data.data.status) {
            toast.success(resp.data.message);
            navigate(
              `/hotel?tid=${JSON.stringify(tripId)}&hid=${JSON.stringify(
                data?.hotels?.id
              )}&tkid=""&checkin=${JSON.stringify(
                format(new Date(data?.checkIn), "yyyy-MM-dd")
              )}&checkout=${JSON.stringify(
                format(new Date(data?.checkOut), "yyyy-MM-dd")
              )}&oc=${JSON.stringify(data?.reqOccupancies)}&ds=${true}`
            );
          } else {
            setLoader(false);
            toast.error(resp.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const getSavedHotels = () => {
    axios
      .get(
        process.env.REACT_APP_BACKEND + `trip/getsavedrooms?tripid=${tripId}`
      )
      .then((resp) => {
        setSavedHotels(resp.data.data);
      })
      .catch((err) => console.log(err));
  };
  const handleSelection = (item) => {
    setSelectedItem(item);
  };
  const handleSubmitHotel = () => {
    let location = selectedItem;
    // dispatch(setSearchCriteria({ location, checkIn, checkOut }));
    // if (
    //   selectedItem !== "" &&
    //   selectedItem !== undefined &&
    //   selectedItem !== null &&
    //   selectedItem?.referenceId !== null &&
    //   selectedItem?.referenceId !== undefined
    // ) {
    // navigate(
    //   `/hotel?tid=${JSON.stringify(tripId)}&locid=${JSON.stringify(
    //     selectedItem.id
    //   )}&hid=${JSON.stringify(
    //     selectedItem?.referenceId
    //   )}&checkin=${JSON.stringify(
    //     format(new Date(dateRange[0].startDate), "yyyy-MM-dd")
    //   )}&checkout=${JSON.stringify(
    //     format(new Date(dateRange[0].endDate), "yyyy-MM-dd")
    //   )}&oc=${JSON.stringify(occupancySelector)}&ds=${true}`
    // );
    //   const url = `/hotel?tid=${JSON.stringify(tripId)}&locid=${JSON.stringify(
    //     selectedItem.id
    //   )}&hid=${JSON.stringify(
    //     selectedItem?.referenceId
    //   )}&checkin=${JSON.stringify(
    //     format(new Date(dateRange[0].startDate), "yyyy-MM-dd")
    //   )}&checkout=${JSON.stringify(
    //     format(new Date(dateRange[0].endDate), "yyyy-MM-dd")
    //   )}&oc=${JSON.stringify(occupancySelector)}&ds=${true}`;

    //   window.open(url, "_blank");
    // } else {
    if (selectedItem && selectedItem?.id) {
      navigate(
        `/search-list?tid=${JSON.stringify(tripId)}&locid=${JSON.stringify(
          selectedItem.id
        )}&checkin=${JSON.stringify(
          format(new Date(dateRange[0].startDate), "yyyy-MM-dd")
        )}&checkout=${JSON.stringify(
          format(new Date(dateRange[0].endDate), "yyyy-MM-dd")
        )}&occupancy=${JSON.stringify(occupancySelector)}`
      );
    }
    // }
  };
  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };
  const changeOccupancySelection = (type, delta) => {
    setOccupancySelector((prev) => {
      const updatedValue = Math.max(
        type === "children" ? 0 : 1,
        prev[type] + delta
      );

      if (type === "children") {
        // Handle children-specific logic
        const updatedChildren = [...prev.children];
        if (delta > 0) {
          // Add new child with default age
          updatedChildren.push({ child: updatedChildren.length + 1, age: "" });
        } else if (delta < 0 && updatedChildren.length > 0) {
          // Remove the last child
          updatedChildren.pop();
        }

        return {
          ...prev,
          children: updatedChildren,
        };
      }

      return {
        ...prev,
        [type]: updatedValue,
      };
    });
  };

  const removeHotelFromTrip = () => {
    setLoader(true);
    const data = {
      savedRoomId: deleteOpen?.data?._id,
    };
    axios
      .post(
        process.env.REACT_APP_BACKEND + "reviewbooking/deletetriproom ",
        data
      )
      .then((resp) => {
        getSavedHotels();
        setDeleteOpen({ status: false, data: null });
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };
  const resendConfirommationEmail = () => {
    setOpenShareTripPopup(false);
  };
  return (
    <>
      {loader && <Loader />}
      <div className="bxShadow cardcont p-4">
        <h3>Find a hotel</h3>
        <div
          className="d-flex align-items-center f-wrap mt-4  "
          style={{ gap: 20 }}
        >
          <div className="w49 ">
            <SearchBox
              apiUrl="autosuggest"
              onSelect={handleSelection}
              placeholder="Search Hotels..."
              valueKey="fullName"
            />
          </div>
          <div className="w49">
            <DateRange
              style={{ left: "0%", top: "-10%" }}
              onDateRangeChange={handleDateRangeChange}
            />
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between my-3 flexWrap jc-center"
          style={{ position: "relative" }}
        >
          <div
            className="d-flex align-items-center mt-4 mb-4"
            style={{ gap: 20 }}
          >
            <div className="d-flex align-items-center adt_btn">
              <div
                className="d-flex align-items-center c-pointer "
                style={{ gap: 10 }}
                onClick={() => setAddAdultsPop(!addAdultsPop)}
              >
                <p>{occupancySelector?.rooms} Rooms</p>
                <p>{occupancySelector?.adults} Adults</p>
                {occupancySelector?.children !== 0 ? (
                  <p>{occupancySelector?.children.length} Children</p>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {!addAdultsPop && (
              <p
                className="d-flex align-items-center adt_btn"
                onClick={() => setAddAdultsPop(true)}
              >
                + Add Traveler
              </p>
            )}
            {addAdultsPop && (
              <div className="trip-ad-pop ">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p>Rooms</p>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{ gap: 20 }}
                  >
                    <button
                      className="btnaddremove "
                      onClick={() => changeOccupancySelection("rooms", -1)}
                    >
                      <RemoveIcon />
                    </button>
                    <p>{occupancySelector?.rooms}</p>
                    <button
                      className="btnaddremove "
                      onClick={() => changeOccupancySelection("rooms", 1)}
                    >
                      <AddIcon />
                    </button>
                  </div>
                </div>
                <hr className="mt-1 mb-1" />
                <div className="d-flex align-items-center justify-content-between mt-1">
                  <div>
                    <p>Adults</p>
                    <p className="fs-8">Ages 18 and older</p>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{ gap: 20 }}
                  >
                    <button
                      className="btnaddremove "
                      onClick={() => changeOccupancySelection("adults", -1)}
                    >
                      <RemoveIcon />
                    </button>
                    <p>{occupancySelector?.adults}</p>
                    <button
                      className="btnaddremove "
                      onClick={() => changeOccupancySelection("adults", 1)}
                    >
                      <AddIcon />
                    </button>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between my-1">
                  <div>
                    <p>Children</p>
                    <p className="fs-8">requires age specification</p>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{ gap: 20 }}
                  >
                    <button
                      className="btnaddremove "
                      onClick={() => changeOccupancySelection("children", -1)}
                    >
                      <RemoveIcon />
                    </button>
                    <p>{occupancySelector?.children.length}</p>
                    <button
                      className="btnaddremove "
                      onClick={() => changeOccupancySelection("children", 1)}
                    >
                      <AddIcon />
                    </button>
                  </div>
                </div>
                {occupancySelector?.children.length !== 0 &&
                  occupancySelector?.children.map((cdata, index) => (
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="fs-8">Age of Child {index + 1}</p>
                      <div className="mt-2">
                        {/* <TextBox
                          type="number"
                          value={cdata.age || ""}
                          onChange={(e) => {
                            const newAge = e.target.value;
                            setOccupancySelector((prev) => ({
                              ...prev,
                              children: prev.children.map((c, i) =>
                                i === index ? { ...c, age: newAge } : c
                              ),
                            }));
                          }}
                          max="18"
                          min="0"
                          style={{ width: "25%", height: "10px" }}
                        /> */}
                        <TextBox
                          type="number"
                          value={cdata.age || ""}
                          onChange={(e) => {
                            const newAge = Number(e.target.value);
                            if (newAge < 0 || newAge > 12) {
                              setError("Age must be between 1 to 12 years.");
                            } else {
                              setError("");
                              setOccupancySelector((prev) => ({
                                ...prev,
                                children: prev.children.map((c, i) =>
                                  i === index ? { ...c, age: newAge } : c
                                ),
                              }));
                            }
                          }}
                          max="12"
                          min="1"
                          style={{ width: "25%", height: "10px" }}
                        />
                      </div>
                    </div>
                  ))}
                {error && (
                  <p
                    className="t-center fs-8"
                    style={{ color: "var(--red-color)" }}
                  >
                    {error}
                  </p>
                )}

                <hr className="mt-1 mb-1" />
                <div
                  className="d-flex align-items-center justify-content-end mt-4 "
                  style={{ gap: 10 }}
                >
                  <button
                    className="btn-outlined"
                    onClick={() => setAddAdultsPop(false)}
                  >
                    Submit
                  </button>
                  {/* <button className="btn-contained ">Done</button> */}
                </div>
              </div>
            )}
          </div>
          <div className="t-center">
            {" "}
            <button
              className="btn-contained d-flex align-items-center "
              onClick={handleSubmitHotel}
            >
              {" "}
              <SearchIcon />
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="bxShadow cardcont p-4 mt-4">
        {savedHotels.length !== 0 ? (
          savedHotels.map((shdata) => (
            <div
              className="bxShadow cardcont p-3"
              style={{ position: "relative" }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                {shdata?.status?.toLowerCase() === "booked" ? (
                  <p>Booking Id - {shdata?.bookingId}</p>
                ) : (
                  <div></div>
                )}
                <h4
                  style={{
                    color:
                      shdata?.status?.toLowerCase() === "booked"
                        ? "var(--primary-color)"
                        : shdata?.status?.toLowerCase() === "failed" ||
                          shdata?.status?.toLowerCase() === "cancelled"
                        ? "var(--red-color)"
                        : "var(--yellow-color)",
                    background:
                      shdata?.status?.toLowerCase() === "booked"
                        ? "#d1fae5"
                        : shdata?.status?.toLowerCase() === "failed" ||
                          shdata?.status?.toLowerCase() === "cancelled"
                        ? "#fdecea "
                        : "#fef9c3  ",
                  }}
                  className="ribbon-2"
                >
                  {shdata?.status.toUpperCase()}
                </h4>
              </div>
              <h3>{shdata?.hotels?.name}</h3>
              <div className="d-flex align-items-center justify-content-between  ">
                <div>
                  <p className="fs-8">
                    Address :- {shdata?.hotels?.contact?.address?.line1} -{" "}
                    {shdata?.hotels?.contact?.address?.postalCode}
                  </p>
                  {shdata?.status?.toLowerCase() === "booked" && (
                    <p className="fs-8">
                      Phone No :-{" "}
                      {shdata?.hotels?.contact?.phones.map((item, index2) => (
                        <span key={index2}>{item} </span>
                      ))}
                    </p>
                  )}
                  <p>
                    {shdata?.roomsAndRates?.name} *{" "}
                    {shdata?.reqOccupancies?.rooms}{" "}
                    {shdata?.reqOccupancies?.rooms === 1 ? "Room" : "Rooms"}{" "}
                  </p>
                </div>
                <div className="d-flex align-items-center" style={{ gap: 15 }}>
                  <div>
                    <p className="fw-700">
                      {/* ${shdata?.roomsAndRates?.totalRate.toFixed(2)} */}
                    </p>
                    <p className="fs-6">{shdata?.tax}</p>
                  </div>
                  <button
                    className=" btn-contained"
                    onClick={() => checkAvaibality(shdata)}
                  >
                    {shdata?.status?.toLowerCase() === "booked"
                      ? "Cancel Booking"
                      : "Check Availability"}
                  </button>
                  {shdata?.status?.toLowerCase() === "booked" && (
                    <button
                      className=" btn-contained"
                      onClick={() => setOpenShareTripPopup(true)}
                    >
                      Confirmation Email
                    </button>
                  )}
                  {shdata?.status?.toLowerCase() !== "booked" && (
                    <Tooltip title="Delete Hotel" placement="top" arrow>
                      <DeleteOutlineIcon
                        className="c-pointer"
                        onClick={() =>
                          setDeleteOpen({ status: true, data: shdata })
                        }
                      />
                    </Tooltip>
                  )}
                </div>
              </div>
              <>
                <div
                  className="d-flex align-items-center mt-3"
                  style={{ gap: 30 }}
                >
                  <div style={{ width: "15%" }}>
                    <img
                      src={shdata?.hotels?.heroImage}
                      className="w100"
                      style={{ borderRadius: "8px" }}
                      alt=""
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-between w80">
                    <div
                      className="d-flex align-items-center "
                      style={{ gap: 20 }}
                    >
                      <p>
                        {shdata?.roomsAndRates?.boardBasis?.type === "HalfBoard"
                          ? "Includes breakfast and one additional meal"
                          : shdata?.roomsAndRates?.boardBasis?.type ===
                            "BedAndBreakfast"
                          ? "Includes breakfast"
                          : shdata?.roomsAndRates?.boardBasis?.description}
                      </p>
                      <div>
                        <p>
                          {formatDateToEEE_MM_d(shdata?.checkIn, "UTC")} -{" "}
                          {formatDateToEEE_MM_d(shdata?.checkOut, "UTC")}
                        </p>
                        <p className="fs-8">{shdata.beds}</p>
                      </div>
                      <div>
                        <p>{shdata?.deposit}</p>
                        <p
                          className=""
                          style={{
                            color:
                              shdata?.roomsAndRates?.refundability ===
                              "Refundable"
                                ? "var(--primary-color)"
                                : "var(--red-color)",
                          }}
                        >
                          {shdata?.roomsAndRates?.refundability}
                        </p>
                      </div>
                    </div>
                    {shdata?.status?.toLowerCase() === "booked" && (
                      <div>
                        <h2>$ {shdata?.roomsAndRates?.adjustedRate}</h2>
                        <p
                          className="fs-8"
                          style={{ color: "var(--grey-color)" }}
                        >
                          Total Amount
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                {shdata?.status?.toLowerCase() === "booked" && (
                  <div>
                    <p className="fs-10 fw-700 ms-2">Cancellation Policy</p>
                    <p className="fs-8 ms-4">
                      •{" "}
                      {shdata?.roomsAndRates?.cancellationPolicies?.[0]
                        ?.rules[0].value === 0
                        ? "No cancellation fee "
                        : ` A cancellation fee of  ${
                            shdata?.roomsAndRates?.cancellationPolicies?.[0]
                              ?.rules[0].valueType === "Percentage"
                              ? `${shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].value}% of the total amount`
                              : `$${shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].value.toFixed(
                                  2
                                )}`
                          }`}{" "}
                      will be charged if you cancel between{" "}
                      {
                        shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].start.split(
                          "T"
                        )[0]
                      }{" "}
                      {shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].start
                        .split("T")[1]
                        .split(":")
                        .slice(0, 2)
                        .join(":")}{" "}
                      and{" "}
                      {
                        shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].end.split(
                          "T"
                        )[0]
                      }{" "}
                      {shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].end
                        .split("T")[1]
                        .split(":")
                        .slice(0, 2)
                        .join(":")}
                    </p>
                    <p className="fs-8 ms-4">
                      •{" "}
                      {shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[
                        shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules
                          .length - 1
                      ].value === 0
                        ? "No cancellation fee "
                        : ` 100% cancellation fee of  `}{" "}
                      will be charged if you cancel after{" "}
                      {
                        shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].end.split(
                          "T"
                        )[0]
                      }{" "}
                      {shdata?.roomsAndRates?.cancellationPolicies?.[0]?.rules[0].end
                        .split("T")[1]
                        .split(":")
                        .slice(0, 2)
                        .join(":")}
                    </p>
                  </div>
                )}
              </>
              {shdata?.status?.toLowerCase() === "saved" && (
                <p
                  className="t-center fs-8"
                  style={{ color: "var(--red-color)" }}
                >
                  * Pricing and availability may change until you book.
                </p>
              )}

              {shdata?.status?.toLowerCase() === "cancelled" &&
                shdata?.refund?.status?.toLowerCase() === "succeeded" && (
                  <p className="t-center mt-2">
                    Successfully refunded ${shdata?.refund?.amount / 100}. It
                    may take a couple of days for the money to reach the your
                    bank account.
                  </p>
                )}
            </div>
          ))
        ) : (
          <div className="t-center">
            {" "}
            <img src={NOHOTELIMG} className="w20" alt="" />
            <p> No Hotels</p>{" "}
          </div>
        )}
      </div>
      <Modal
        open={cancelPopUp}
        onClose={() => {
          setCancelPopUp(false);
          setSelectedItem(null);
        }}
        title="Cancel Booking"
      >
        <div>
          <p className="mb-4 mt-2">
            Are you Sure you want to cancel the booking?
          </p>

          <div
            className="d-flex align-item-center justify-content-end mt-3"
            style={{ gap: "20px" }}
          >
            <button
              className="btn-contained"
              onClick={() => {
                setCancelPopUp(false);
                setSelectedItem(null);
              }}
            >
              Close
            </button>
            <button className="btn-outlined" onClick={() => cancelbooking()}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={deleteOpen?.status}
        onClose={() => setDeleteOpen({ status: false, data: null })}
        title="Delete Hotel"
        size="sm"
      >
        <p className="mt-4">
          Are you sure you want to delete the hotel from trip?
        </p>
        <div
          className="mt-4 d-flex alifn-items-center justify-content-end"
          style={{ gap: 20 }}
        >
          <button
            className="btn-outlined"
            onClick={() => setDeleteOpen({ status: false, data: null })}
          >
            Close
          </button>
          <button className="btn-contained" onClick={removeHotelFromTrip}>
            Confirm
          </button>
        </div>
      </Modal>
      <Modal
        open={openShareTripPopup}
        onClose={() => setOpenShareTripPopup(false)}
        title="Resend Booking Details"
        size="sm"
      >
        {/* <p className="mt-4">
          Are you sure you want to delete the hotel from trip?
        </p> */}
        <TextBox
          label="Email"
          type="email"
          placeholder="Email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div
          className="mt-4 d-flex alifn-items-center justify-content-end"
          style={{ gap: 20 }}
        >
          <button
            className="btn-outlined"
            onClick={() => setOpenShareTripPopup(false)}
          >
            Close
          </button>
          <button className="btn-contained" onClick={resendConfirommationEmail}>
            Send Email
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddHotel;
